{
  "app": {
    "name": "Delta WorkForce",
    "tagline": "Workforce platform for Stanford Facilities"
  },
  "nav": {
    "home": "Home",
    "workOrders": "Work Orders",
    "scan": "Scan",
    "timecards": "Timecards",
    "notifications": "Notifications",
    "whatsNew": "What's New",
    "approvals": "Approvals",
    "team": "Team",
    "assets": "Assets",
    "locations": "Locations",
    "map": "Map",
    "crew": "Crew",
    "schedule": "Schedule",
    "parts": "Parts",
    "tools": "Tools",
    "vendors": "Vendors",
    "leaderboard": "Leaderboard",
    "kudos": "Kudos",
    "messages": "Messages",
    "feedback": "Feedback",
    "insights": "Insights",
    "reports": "Reports",
    "communications": "Comms Drafter",
    "howto": "How-To Drafts",
    "forms": "Forms",
    "admin": "Admin",
    "more": "More",
    "settings": "Settings",
    "integrations": "Integrations",
    "invoiceQueue": "Invoice Queue",
    "dispatch": "Dispatch",
    "fleetCalendar": "Fleet Calendar",
    "vehicles": "Vehicles",
    "fleetDashboards": "Fleet Dashboards",
    "approvalsQueue": "Approvals Queue",
    "serviceWindows": "Service Windows",
    "fleetAdmin": "Fleet Admin",
    "lifecycle": "Lifecycle",
    "transfers": "Transfers",
    "myVehicles": "My Vehicles",
    "myApprovals": "Pending Approvals",
    "approvalHistory": "History",
    "impersonate": "Impersonate",
    "dashboardEditor": "Dashboard Editor",
    "automations": "Automations",
    "pmSchedules": "PM Schedules",
    "workforceCalendar": "Calendar",
    "help": "Help Center"
  },
  "nav_desc": {
    "home": "Your daily snapshot — what to do next, fast.",
    "workOrders": "Open jobs, status, hazards, and history.",
    "timecards": "Log hours against work orders or general time.",
    "approvals": "Review pending requests waiting on you.",
    "team": "Roster, assignments, and who is on shift.",
    "insights": "Trends across work orders, time, and teams.",
    "reports": "Saved reports and exports for stakeholders.",
    "communications": "AI-assisted updates for tenants and stakeholders.",
    "howto": "Capture and refine standard operating procedures.",
    "forms": "Inspection and compliance forms by trade.",
    "assets": "Equipment lookup, manuals, and service history.",
    "locations": "Buildings, rooms, and site information.",
    "map": "Campus map with active jobs and assets.",
    "crew": "Crew roster, certs, and contact info.",
    "schedule": "Shift calendar and assignments.",
    "parts": "Parts catalog, stock, and reorder.",
    "tools": "Tool checkout, calibration, and inventory.",
    "vendors": "Outside contractors, contracts, and contacts.",
    "leaderboard": "Friendly competition across crews.",
    "kudos": "Recognize great work from teammates.",
    "messages": "Channels and direct conversations.",
    "whatsNew": "Recent platform updates and release notes.",
    "settings": "Profile, notifications, and preferences.",
    "integrations": "Maximo, SSO, and other system connections.",
    "admin": "Tenant settings, users, and audit log.",
    "more": "All apps available to you.",
    "invoiceQueue": "Three-way match review for vendor invoices.",
    "dispatch": "Assign work orders to your technicians.",
    "fleetCalendar": "Staging appointments and vendor scheduling.",
    "vehicles": "Fleet vehicles, recalls, and service history.",
    "fleetDashboards": "Out-for-service, overdue WOs, vendor performance.",
    "approvalsQueue": "Customer approval tracking and escalation.",
    "serviceWindows": "Vendor service windows, slot offers, and operator bookings.",
    "fleetAdmin": "Insurance, registration, leases, transfers, disposals.",
    "lifecycle": "Vehicle lifecycle timeline, TCO, and sub-records.",
    "transfers": "Inter-department vehicle transfers and approvals.",
    "myVehicles": "Your department vehicles and service status.",
    "myApprovals": "Repair estimates awaiting your approval.",
    "approvalHistory": "Past approval decisions and service records.",
    "impersonate": "View the app as another user (read-only).",
    "dashboardEditor": "Configure home page widgets per role.",
    "automations": "Scheduled jobs and on-demand automation tasks.",
    "pmSchedules": "Recurring preventive maintenance work order schedules.",
    "workforceCalendar": "Schedule, leave requests, and overtime tracking.",
    "help": "Interactive workflow guides and role spotlights."
  },
  "actions": {
    "save": "Save",
    "saveDraft": "Save draft",
    "cancel": "Cancel",
    "submit": "Submit",
    "delete": "Delete",
    "edit": "Edit",
    "create": "Create",
    "add": "Add",
    "remove": "Remove",
    "assign": "Assign",
    "unassign": "Unassign",
    "approve": "Approve",
    "reject": "Reject",
    "close": "Close",
    "back": "Back",
    "next": "Next",
    "done": "Done",
    "search": "Search",
    "filter": "Filter",
    "clear": "Clear",
    "upload": "Upload",
    "takePhoto": "Take photo",
    "translate": "Translate",
    "showOriginal": "Show original",
    "viewAll": "View all",
    "viewMore": "View more",
    "loading": "Loading…",
    "retry": "Retry",
    "signIn": "Sign in",
    "signOut": "Sign out"
  },
  "status": {
    "open": "Open",
    "assigned": "Assigned",
    "inProgress": "In progress",
    "onHold": "On hold",
    "completed": "Completed",
    "closed": "Closed",
    "cancelled": "Cancelled",
    "available": "Available",
    "onLeave": "On leave",
    "offDuty": "Off duty"
  },
  "priority": {
    "emergency": "Emergency",
    "urgent": "Urgent",
    "high": "High",
    "medium": "Medium",
    "low": "Low"
  },
  "fields": {
    "description": "Description",
    "location": "Location",
    "trade": "Trade",
    "priority": "Priority",
    "assignedTo": "Assigned to",
    "dueDate": "Due date",
    "estimatedHours": "Estimated hours",
    "status": "Status",
    "name": "Name",
    "email": "Email",
    "phone": "Phone",
    "role": "Role",
    "notes": "Notes"
  },
  "validation": {
    "required": "Required",
    "mustBeNumber": "Must be a number",
    "minLength": "Too short",
    "maxLength": "Too long",
    "invalidEmail": "Invalid email"
  },
  "notify": {
    "critical": "CRITICAL",
    "important": "IMPORTANT",
    "info": "INFO"
  },
  "common": {
    "yes": "Yes",
    "no": "No",
    "none": "None",
    "all": "All",
    "any": "Any",
    "unknown": "Unknown",
    "notAvailable": "Not available"
  },
  "settings": {
    "language": "Language",
    "preferences": "Preferences",
    "profile": "Profile",
    "theme": "Theme",
    "textSize": "Text Size",
    "textSizeHint": "Adjusts all text and UI elements across the app",
    "simplified": "Simplified mode (larger touch targets + text)",
    "themeDark": "Default",
    "themeDarkDesc": "Industrial dark — default",
    "themeLight": "Light",
    "themeLightDesc": "Clean white surfaces",
    "themeHighContrast": "High contrast",
    "themeHighContrastDesc": "OLED true-black",
    "themeSunlight": "Sunlight",
    "themeSunlightDesc": "Outdoor max contrast",
    "themeTechConnect": "TechConnect",
    "themeTechConnectDesc": "Stanford Cardinal red & gold"
  },
  "translate": {
    "translateButton": "Translate",
    "translating": "Translating…",
    "translatedFrom": "Translated from {{lang}}",
    "failed": "Translation failed"
  },
  "pages": {
    "helpCenter": "Help Center",
    "helpCenterDesc": "Understand how key workflows work — who does what, in what order, and where it happens.",
    "allRoles": "All Roles",
    "searchFlows": "Search flows, roles, or actions...",
    "noFlowsFound": "No flows found. Try a different search.",
    "flowNotFound": "Flow not found.",
    "backToHelp": "Back to Help Center",
    "stepsInDetail": "Steps in detail",
    "workOrders": "Work Orders",
    "newWorkOrder": "New Work Order",
    "searchWO": "Search by description, location, or ID…",
    "insights": "Insights",
    "insightsDesc": "Ask natural-language questions, review dashboards, and spot anomalies.",
    "askQuestion": "Ask a question",
    "askPlaceholder": "e.g., How many HVAC WOs last month?",
    "ask": "Ask",
    "anomalies": "Anomalies",
    "compliance": "Compliance scorecard",
    "vendors": "Vendors",
    "forms": "Forms",
    "formBuilder": "Form Builder",
    "formDetails": "Form Details",
    "addField": "Add Field",
    "livePreview": "Live Preview",
    "exitPreview": "Exit preview",
    "preview": "Preview",
    "tools": "Tools",
    "leaderboard": "Leaderboard",
    "kudos": "Kudos",
    "chooseTechmate": "Choose a teammate…",
    "reports": "Reports",
    "howToDrafts": "How-To Drafts",
    "commsDrafter": "Communications Drafter",
    "crew": "Crew",
    "locations": "Locations",
    "partsCatalog": "Parts Catalog",
    "assets": "Assets",
    "messages": "Messages",
    "allChannels": "All channels",
    "feedback": "Feedback",
    "fleetVehicles": "Fleet Vehicles",
    "fleetCalendar": "Fleet Calendar",
    "approvalsQueue": "Approvals Queue",
    "noApprovals": "No approvals in queue",
    "pendingApprovals": "Pending Approvals",
    "noPendingApprovals": "No pending approvals",
    "approvalHistory": "Approval History",
    "noHistory": "No history yet",
    "myVehicles": "My Vehicles",
    "noVehicles": "No vehicles assigned",
    "schedule": "Schedule",
    "notifications": "Notifications",
    "markAllRead": "Mark all read",
    "adminConsole": "Admin Console",
    "integrations": "Integrations",
    "invoiceQueue": "Invoice Review Queue",
    "dashboardEditor": "Dashboard Editor",
    "savedChanges": "Saved",
    "saveChanges": "Save Changes",
    "map": "Map",
    "locateMe": "Locate me",
    "includeClosed": "Include closed",
    "searchPins": "Search pins…",
    "navigate": "Navigate"
  },
  "filters": {
    "allTrades": "All Trades",
    "allStatuses": "All Statuses",
    "allTypes": "All Types",
    "allRoles": "All Roles",
    "allCategories": "All Categories",
    "allKinds": "All Kinds",
    "allPriorities": "All Priorities",
    "allFuelTypes": "All fuel types",
    "allMethods": "All Methods",
    "allEntityTypes": "All Entity Types"
  },
  "trades": {
    "hvac": "HVAC",
    "plumbing": "Plumbing",
    "electrical": "Electrical",
    "general": "General"
  },
  "fleet": {
    "ice": "ICE",
    "ev": "EV",
    "phev": "PHEV",
    "hybrid": "Hybrid",
    "available": "Available",
    "inService": "In Service",
    "outForService": "Out for Service",
    "scheduled": "Scheduled",
    "staged": "Staged",
    "pickedUp": "Picked Up",
    "returned": "Returned",
    "canceled": "Canceled",
    "escalated": "Escalated",
    "aging": "Aging",
    "pending": "Pending",
    "proposed": "Proposed",
    "cedingApproved": "Ceding Approved",
    "receivingApproved": "Receiving Approved",
    "executed": "Executed"
  },
  "calendar": {
    "leave": "Leave",
    "overtime": "OT",
    "leaveRequest": "Leave Request",
    "overtimeRequest": "Overtime Request",
    "pendingRequests": "Pending Requests",
    "workOrders": "Work Orders",
    "hours": "Hours",
    "reason": "Reason",
    "tech": "Tech",
    "hrs": "Hrs",
    "prev": "Prev",
    "next": "Next"
  },
  "widgets": {
    "myWork": "My Work Orders",
    "timecards": "Timecards",
    "thisWeek": "This week",
    "fleetStatus": "Fleet Status",
    "pendingApprovals": "Pending Approvals",
    "teamAvailability": "Team Availability",
    "recentMessages": "Recent Messages",
    "quickLinks": "Quick Links"
  },
  "ai": {
    "formBuilder": "AI Form Builder",
    "describeForm": "Describe the form you need",
    "generating": "Generating…",
    "generateForm": "Generate Form"
  },
  "groups": {
    "Work": "Work",
    "People": "People",
    "Assets": "Assets",
    "Fleet": "Fleet",
    "Insights": "Insights",
    "Admin": "Admin",
    "Preferences": "Preferences"
  },
  "groups_desc": {
    "Work": "Daily tasks, time tracking, and approvals.",
    "People": "Teams, crews, schedules, and vendors.",
    "Assets": "Equipment, locations, parts, and tools.",
    "Fleet": "Vehicle logistics, staging, and lifecycle.",
    "Insights": "Analytics, reports, and recognition.",
    "Admin": "PM schedules, automations, forms, and system.",
    "Preferences": "Help, release notes, and personal settings."
  },
  "more": {
    "title": "More",
    "subtitle": "Tap a group to see its apps."
  },
  "home": {
    "goodMorning": "Good morning",
    "goodAfternoon": "Good afternoon",
    "goodEvening": "Good evening",
    "loading": "Loading dashboard..."
  },
  "roles": {
    "technician": "Technician",
    "supervisor": "Supervisor",
    "admin": "Administrator",
    "sysadmin": "System Admin",
    "vendor_admin": "Vendor Admin",
    "vendor_supervisor": "Vendor Supervisor",
    "vendor_tech": "Vendor Technician",
    "customer_operator": "Customer / Operator"
  },
  "login": {
    "chooseOrg": "Choose an organization to explore",
    "heritage": "Every business process LBRE refined in TechConnect is carried forward — rebuilt for speed, clarity, and the future of Stanford Facilities."
  },
  "sw": {
    "pageTitle": "Service Windows",
    "headerStats": "{{published}} published · {{drafts}} drafts ({{pmDrafts}} from PM)",
    "filterAll": "All statuses",
    "statusDraft": "Draft",
    "statusPublished": "Published",
    "statusCanceled": "Canceled",
    "newWindow": "New window",
    "loading": "Loading…",
    "loadingTimes": "Loading available times…",
    "emptyTitle": "No service windows yet",
    "emptyDesc": "Author one manually or enable the PM auto-seed scheduler.",
    "today": "Today",
    "capacityLabel": "capacity {{n}}",
    "cohortLabel": "cohort: {{type}}",
    "vendorLabel": "vendor {{id}}",
    "publishTitle": "Publish",
    "cancelWindowTitle": "Cancel window",
    "pmDraftsTitle": "PM-seeded drafts ({{count}})",
    "pmDraftsEmpty": "No PM drafts in the queue. Enable the scheduler in System Settings to auto-seed.",
    "publishAllDrafts": "Publish all {{count}} drafts",
    "thisHorizon": "This horizon",
    "totalWindows": "Total windows",
    "statsPublished": "Published",
    "statsDrafts": "Drafts",
    "composerTitle": "New service window",
    "fieldStart": "Start",
    "fieldEnd": "End",
    "fieldLocation": "Location",
    "locationPlaceholder": "Garage Bay 2 · LBRE",
    "fieldVendorId": "Vendor id",
    "vendorIdPlaceholder": "grainger-uuid",
    "fieldCapacity": "Capacity",
    "fieldCohort": "Vehicle cohort (type tag)",
    "cohortPlaceholder": "transit-van · cart · bolt-ev · …",
    "publishImmediately": "Publish immediately (otherwise save as draft)",
    "cancel": "Cancel",
    "saving": "Saving…",
    "publish": "Publish",
    "saveDraft": "Save draft",
    "errInvalidTimes": "Enter valid start and end times.",
    "errEndBeforeStart": "End must be after start.",
    "errStartPast": "Window must start in the future.",
    "errLocationRequired": "Location is required.",
    "errVendorRequired": "Vendor id is required.",
    "errCapacityRange": "Capacity must be 1–50.",
    "errCreateFailed": "Failed to create window",
    "vendorPageTitle": "Confirm Service Windows",
    "statsPending": "Pending offers",
    "statsConfirmed": "Confirmed",
    "statsDeclined": "Declined",
    "statsTotal": "Total in horizon",
    "vendorEmptyTitle": "No service window offers",
    "vendorEmptyDesc": "When Fleet Admin publishes a window assigned to your org, it'll appear here.",
    "mixedCohort": "mixed cohort",
    "locationColon": "Location:",
    "partialConfirmed": "Partial · {{confirmed}} of {{total}} confirmed",
    "statusDeclined": "Declined",
    "statusAccepted": "Accepted",
    "confirmedCapacity": "Confirmed capacity:",
    "save": "Save",
    "accept": "Accept",
    "partial": "Partial",
    "decline": "Decline",
    "acceptTitle": "Accept full window",
    "partialTitle": "Partial accept",
    "declineTitle": "Decline",
    "operatorPageTitle": "Pick a service time",
    "forYourVehicle": "For your vehicle",
    "selectVehicle": "Select a vehicle…",
    "emptyVehicleTitle": "Select a vehicle",
    "emptyVehicleDesc": "Pick one of your vehicles to see available service times.",
    "noWindowsTitle": "No available windows",
    "noWindowsDesc": "Fleet Admin and the vendor haven't confirmed any times for this vehicle yet.",
    "availableSlots_one": "{{count}} available slot",
    "availableSlots_other": "{{count}} available slots",
    "next30Days": "next 30 days",
    "booking": "Booking…",
    "selectWindowAbove": "Select a window above",
    "bookSlot": "Book {{date}} · {{time}}",
    "publicBrand": "Delta WorkForce · Fleet",
    "forYour": "For your",
    "bookedSuccess": "✓ Booked! Your service window is confirmed. You'll receive a reminder before staging.",
    "noWindowsPublic": "No available windows. Check back after Fleet Admin publishes new ones.",
    "confirmBooking": "Confirm booking",
    "publicFooter": "This link is bound to your vehicle. Forwarding it will not record a booking.",
    "errMissingToken": "Missing token",
    "errPickLinkInvalid": "Pick link invalid",
    "errBookingFailed": "Booking failed"
  }
}
